var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('div',{attrs:{"id":"ad"}},[_c('a',{attrs:{"href":"https://www.alearn.org.tw","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"ad",attrs:{"src":"/ad-be.jpg","alt":_vm.sify('按此瞭解更多')}}),_vm._v(_vm._s(_vm.sify('自主學習進促進會製作')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }